export default __webpack_public_path__ + "static/media/blue-success.b9a62145.svg";